import { EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type FrontdoorEvents = 'INIT_EXIT' | 'DIALOG_CANCEL' | 'DIALOG_DISCARD' | 'DIALOG_RESUME_LATER' | 'COMPLETE';

export const frontdoor: Record<FrontdoorEvents, MixpanelEvent> = {
  INIT_EXIT: {
    eventDescription: 'Frontdoor Exit Button',
    eventKey: 'frontdoor-init-exit-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  DIALOG_CANCEL: {
    eventDescription: 'Frontdoor Cancel Dialog Button',
    eventKey: 'frontdoor-dialog-cancel-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  DIALOG_DISCARD: {
    eventDescription: 'Frontdoor Discard Button',
    eventKey: 'frontdoor-dialog-discard-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  DIALOG_RESUME_LATER: {
    eventDescription: 'Frontdoor Resume Later Button',
    eventKey: 'frontdoor-dialog-resume-later-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  },
  COMPLETE: {
    eventDescription: 'Frontdoor Complete',
    eventKey: 'frontdoor-complete',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK
  }
} as const;
